import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';
import { moduleConfig } from './config';
import { buildListQuery, ListQueryOptions, normalizePaginatedListResponse, PaginatedApiResponse } from '../../../services/paginatedList';

export interface AccPeriod {
  id: number;
  year: number;
  startDate: string;
  endDate: string;
  status: 'OPEN' | 'LOCKED';
  createdAt: string;
  updatedAt: string;
}

export const useAccPeriods = (searchParams?: string, page = 1, limit = 25, options?: ListQueryOptions) => {
  const q = buildListQuery(searchParams, page, limit, options);
  const { data, error, isLoading, mutate } = useSWR<PaginatedApiResponse<AccPeriod> | AccPeriod[]>(
    `${moduleConfig.module.api.list}${q}`,
    fetcher,
  );
  const normalized = normalizePaginatedListResponse<AccPeriod>(data, page, limit);
  return { data: normalized.data, total: normalized.total, isLoading, isError: error, mutate };
};

export const useAccPeriod = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<AccPeriod>(id ? moduleConfig.module.api.detail(id) : null, fetcher);
  return { data, item: data, isLoading, isError: error, mutate };
};
